import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Card } from '@mui/material';
import { AppCardSection, AppPage, AppTabs } from '@shared';
import BrightPearlLogin from './BrightPearlLogin';

import { brightpearlIntegrationShape } from 'utils/shapes';

const propTypes = {
  brightPearl: brightpearlIntegrationShape.isRequired
};

const defaultProps = {

}


const SettingsContainer = (props) => {
  const [selected, setSelected] = useState(0);
  const [loading, setLoading] = useState(false);

  const tabs = [
    { id: "brightPearl", content: "Bright Pearl" },
  ]

  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    [],
  );

  return(
    <AppPage
      title="Configuraciones"
      breadcrumbs={[{content: I18n.t("actions.back"), url: '/'}]}
    >
      <Card>
        <AppTabs
          tabs={tabs} selected={selected} onSelect={handleTabChange}>
          <AppCardSection>

            { selected == 0 && <BrightPearlLogin setLoading={setLoading} loading={loading} {...props.brightPearl} /> }

          </AppCardSection>
        </AppTabs>
      </Card>
    </AppPage>
  );
};

SettingsContainer.propTypes = propTypes;
SettingsContainer.defaultProps = defaultProps;

export default SettingsContainer;